/*
 * Allows the creation of chain events that will execute in sequence. One 
 * event can execute at a time. The second event cannot start until the 
 * prior event releases the lock
 *
 * Call requestLock(event, scope) to start the event. If there is already
 * a lock the event will be placed in queue for later execution until the lock
 * is released using FIFO
 */

var BlockingEvents = function() {
    this._queue = []
    this._lock = false
}

BlockingEvents.prototype = {
    /*
		 * Call this function to request a lock and execute the event.
		 * If there is no lock the event is executed. Otherwise, it is 
		 * placed in queue
		 */
    requestLock: function(event, scope) {
        if (this._lock) {
            if (event !== undefined) {
                this._queue.push({
                    event: event,
                    scope: scope === undefined ? null : scope,
                })
            }
            return false
        } else {
            this._lock = true
            this._executeEvent(event, scope)
            return true
        }
    },

    /*
		 * Releases the lock. Next event in queue will get executed and the
		 * event will acquire the lock again. If no events in queue the lock
		 * will be released
		 */
    releaseLock: function() {
        if (this._lock) {
            if (this._queue.length === 0) {
                this._lock = false
            } else {
                var item = this._queue.splice(0, 1)
                item = item[0]
                this._executeEvent(item.event, item.scope)
            }
        }
    },

    _executeEvent: function(event, scope) {
        if (event === undefined) {
            return
        }
        if (scope === null || scope === undefined) {
            event()
        } else {
            event.call(scope)
        }
    },
}

export default BlockingEvents
